import Cards from '../../../constants/cards.constant';
import { Order } from '../interfaces/order.interface';

const parseOrder = (data: Order) => {
  const parseData = { ...data };

  const parsePayments = parseData.details.payments.map(payment => {
    Cards.forEach((value, key) => {
      if (key === payment.description) {
        payment.description = value;
      }
    }, Cards);

    return payment;
  });

  parseData.details.payments = parsePayments;
  return parseData;
};

export default parseOrder;
